/* eslint-disable no-self-assign */
import landingPage from '@/api/landingPage'
import get from 'lodash/get'

const INITIAL_STATE = {
  landingPageList: {},
  landingPageLabels: [],
}

export default {
  namespace: 'landingPage',

  state: INITIAL_STATE,

  reducers: {
    init() {
      return { ...INITIAL_STATE }
    },
    setLandingPageList(state, { payload }) {
      return { ...state, landingPageList: payload }
    },
    setLandingPageLabels(state, { payload }) {
      return { ...state, landingPageLabels: payload }
    },
  },

  effects: {
    *createLandingPage({ payload, successCallback, errorCallback }, { call, select, put }) {
      const { account } = yield select(state => state.auth)
      const response = yield call(landingPage.createLandingPage, {
        data: {
          ...payload,
          accountId: get(account, 'accountId'),
        },
        params: { accountId: get(account, 'accountId') },
      })

      const { status, data: resData } = response

      let error = ''

      if (status === 200) {
        const { success, message } = resData
        if (success) {
          error = undefined
          successCallback?.()
        } else {
          error = message
        }
      }
      if (error) {
        yield put({ type: 'app/notify', payload: { message: error, severity: 'error' } })
        errorCallback?.(error)
      }
    },

    *editLandingPage({ payload, successCallback, errorCallback }, { call, select, put }) {
      const { account } = yield select(state => state.auth)
      const response = yield call(landingPage.editLandingPage, {
        data: {
          ...payload,
          accountId: get(account, 'accountId'),
        },
        params: { accountId: get(account, 'accountId') },
      })

      const { status, data: resData } = response

      let error = ''

      if (status === 200) {
        const { success, message } = resData
        if (success) {
          error = undefined
          successCallback?.()
        } else {
          error = message
        }
      }
      if (error) {
        yield put({ type: 'app/notify', payload: { message: error, severity: 'error' } })
        errorCallback?.(error)
      }
    },

    *getAddableLandingPages({ payload, successCallback, errorCallback }, { call, select }) {
      const { account } = yield select(state => state.auth)

      const response = yield call(landingPage.getAddableLandingPages, {
        params: { accountId: get(account, 'accountId'), ...payload },
      })

      const { status, data: resData } = response

      let hasError = true

      if (status === 200) {
        hasError = false

        successCallback?.(resData)
      }
      if (hasError) {
        errorCallback?.()
      }
    },

    *getLandingPages({ payload, successCallback, errorCallback }, { call, put, select }) {
      const { account } = yield select(state => state.auth)
      const response = yield call(landingPage.getLandingPages, {
        params: { ...payload, accountId: get(account, 'accountId') },
      })
      const { status, data: resData } = response
      let hasError = true

      if (status === 200) {
        hasError = false

        yield put({ type: 'landingPage/setLandingPageList', payload: resData })
        successCallback?.(resData)
      }
      if (hasError) {
        errorCallback?.()
      }
    },

    *getLandingPageLabels({ payload, successCallback, errorCallback }, { call, select, put }) {
      const { account } = yield select(state => state.auth)
      const response = yield call(landingPage.getLandingPageLabels, {
        params: { accountId: get(account, 'accountId'), ...payload },
      })

      const { status, data: resData } = response

      let hasError = true

      if (status === 200) {
        hasError = false

        yield put({ type: 'landingPage/setLandingPageLabels', payload: resData })

        successCallback?.(resData)
      }
      if (hasError) {
        errorCallback?.()
      }
    },

    *getLandingPageAddableLabels({ payload, successCallback, errorCallback }, { call, select }) {
      const { account } = yield select(state => state.auth)
      const { landingpageTempId, ...restPayload } = payload
      const response = yield call(landingPage.getLandingPageAddableLabels, {
        landingpageTempId,
        params: { accountId: get(account, 'accountId'), ...restPayload },
      })
      const { status, data: resData } = response

      let hasError = true

      if (status === 200) {
        hasError = false

        successCallback?.(resData)
      }
      if (hasError) {
        errorCallback?.()
      }
    },

    *getLandingPageLabelsById({ payload, successCallback, errorCallback }, { call, select }) {
      const { account } = yield select(state => state.auth)
      const response = yield call(landingPage.getLandingPageLabelsById, {
        ...payload,
        params: { accountId: get(account, 'accountId') },
      })
      const { status, data: resData } = response
      let error = true

      if (status === 200) {
        const { success, message, data } = resData
        if (success) {
          error = undefined

          successCallback?.(data)
        } else {
          error = message
        }
      }
      if (error) {
        errorCallback?.()
      }
    },

    *getLandingPageById({ payload, successCallback, errorCallback }, { call, select }) {
      const { account } = yield select(state => state.auth)
      const response = yield call(landingPage.getLandingPageById, {
        ...payload,
        params: { accountId: get(account, 'accountId') },
      })
      const { status, data: resData } = response
      let error = true

      if (status === 200) {
        const { success, message, data } = resData
        if (success) {
          error = undefined

          successCallback?.(data)
        } else {
          error = message
        }
      }
      if (error) {
        errorCallback?.()
      }
    },

    *getLandingPageHtml({ payload, successCallback, errorCallback }, { call, select }) {
      const { account } = yield select(state => state.auth)
      const response = yield call(landingPage.getLandingPageHtml, {
        ...payload,
        params: { accountId: get(account, 'accountId') },
      })
      const { status, data: resData } = response
      let error = true

      if (status === 200) {
        const { success, message, data } = resData
        if (success) {
          error = undefined

          successCallback?.(data)
        } else {
          error = message
        }
      }
      if (error) {
        errorCallback?.()
      }
    },

    *deleteLandingPage({ payload, successCallback, errorCallback }, { call, select }) {
      const { account } = yield select(state => state.auth)
      const response = yield call(landingPage.deleteLandingPage, {
        ...payload,
        params: { accountId: get(account, 'accountId') },
      })

      const { status, data: resData } = response

      let error = ''

      if (status === 200) {
        const { success, message } = resData
        if (success) {
          error = undefined
          successCallback?.()
        } else {
          error = message
        }
      }
      if (error) {
        errorCallback?.(error)
      }
    },

    *deleteLandingPageLabel({ payload, successCallback, errorCallback }, { call, select }) {
      const { account } = yield select(state => state.auth)
      const response = yield call(landingPage.deleteLandingPageLabel, {
        ...payload,
        params: { accountId: get(account, 'accountId') },
      })

      const { status, data: resData } = response

      let error = ''

      if (status === 200) {
        const { success, message } = resData
        if (success) {
          error = undefined
          successCallback?.()
        } else {
          error = message
        }
      }
      if (error) {
        errorCallback?.(error)
      }
    },

    *uploadLandingPageImage({ payload, successCallback, errorCallback }, { call, select }) {
      const { account } = yield select(state => state.auth)
      const response = yield call(landingPage.uploadLandingPageImage, {
        data: payload,
        params: { accountId: get(account, 'accountId') },
      })

      const { status, data: resData } = response

      let error = ''

      if (status === 200) {
        const { success, message, data } = resData
        if (success) {
          error = undefined
          successCallback?.(data)
        } else {
          error = message
          errorCallback?.(error)
        }
      }
    },
  },
}
